import React from 'react';
import styles from './DataPribadiForm.module.css';
import InputField from '../common/InputField';
import { useForm } from '../../contexts/FormContext';

function DataPribadiForm() {
    const { 
        formData, 
        handleChange, 
        errors 
    } = useForm();

    const jenisKelaminOptions = [
        { value: 'Laki-laki', label: 'Laki-laki' },
        { value: 'Perempuan', label: 'Perempuan' },
    ];

    return (
        <div className={styles.container}>
            <h2 className={styles.title}>Data Pribadi Jamaah</h2>
            <p>Silakan isi informasi pribadi calon jamaah dengan lengkap.</p>

            <div className={styles.formSection}>
                <div className={styles.formRow}>
                    <InputField
                        label="Nama Lengkap"
                        name="nama_lengkap"
                        value={formData.nama_lengkap}
                        onChange={handleChange}
                        error={errors.nama_lengkap}
                        required
                    />
                    <InputField
                        label="NIK"
                        name="nik"
                        value={formData.nik}
                        onChange={handleChange}
                        error={errors.nik}
                        required
                        maxLength={16}
                        helperText="Nomor Induk Kependudukan 16 digit"
                    />
                </div>

                <div className={styles.formRow}>
                    <InputField
                        label="Tempat Lahir"
                        name="tempat_lahir"
                        value={formData.tempat_lahir}
                        onChange={handleChange}
                        error={errors.tempat_lahir}
                        required
                    />
                    <InputField
                        label="Tanggal Lahir"
                        name="tanggal_lahir"
                        type="date"
                        value={formData.tanggal_lahir}
                        onChange={handleChange}
                        error={errors.tanggal_lahir}
                        required
                    />
                </div>

                <div className={styles.formRow}>
                    <InputField
                        label="Jenis Kelamin"
                        name="jenis_kelamin"
                        value={formData.jenis_kelamin}
                        onChange={handleChange}
                        error={errors.jenis_kelamin}
                        select
                        options={jenisKelaminOptions}
                    />
                    <InputField
                        label="Kewarganegaraan"
                        name="kewarganegaraan"
                        value={formData.kewarganegaraan}
                        onChange={handleChange}
                        error={errors.kewarganegaraan}
                        placeholder="Contoh: Indonesia"
                    />
                </div>

                <InputField
                    label="Alamat Lengkap"
                    name="alamat_lengkap"
                    value={formData.alamat_lengkap}
                    onChange={handleChange}
                    error={errors.alamat_lengkap}
                    textarea
                    rows={3}
                    required
                />

                <div className={styles.formRow}>
                    <InputField
                        label="Nomor Telepon"
                        name="nomor_telepon"
                        type="tel"
                        value={formData.nomor_telepon}
                        onChange={handleChange}
                        error={errors.nomor_telepon}
                        placeholder="contoh: +62812xxxxx"
                    />
                    <InputField
                        label="Email"
                        name="email"
                        type="email"
                        value={formData.email}
                        onChange={handleChange}
                        error={errors.email}
                        placeholder="contoh: email@contoh.com"
                    />
                </div>
            </div>
        </div>
    );
}

export default DataPribadiForm;